import { render } from "./RegisterUserForm.vue?vue&type=template&id=1dc68bd0"
import script from "./RegisterUserForm.vue?vue&type=script&lang=js"
export * from "./RegisterUserForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tannerwelton/Development/zulu-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__